import { render, staticRenderFns } from "./RenderEmpty.vue?vue&type=template&id=1129366c&scoped=true"
import script from "./RenderEmpty.vue?vue&type=script&lang=js"
export * from "./RenderEmpty.vue?vue&type=script&lang=js"
import style0 from "./RenderEmpty.vue?vue&type=style&index=0&id=1129366c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1129366c",
  null
  
)

export default component.exports